import React, { RefObject } from 'react'
import { useTranslation } from 'react-i18next'
import { LuSearch } from 'react-icons/lu'
import { Flex } from '@chakra-ui/react'

import { Input } from '../Input'

import { ButtonWithIcon } from './styles'

type Props = {
  placeholder: string
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement> | any, value?: any) => void
  name: string
  onClick: () => void
  shouldHideButton?: boolean
  inputRef?: RefObject<HTMLInputElement | null>
}

export const InputWithButton: React.FC<Props> = ({
  placeholder,
  name,
  value,
  onChange,
  onClick,
  shouldHideButton = false,
  inputRef,
}) => {
  const { t } = useTranslation('common')

  return (
    <Flex position="relative" width="100%">
      <Input
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        name={name}
        label={t('searchInputPlaceholder') || 'searchInputPlaceholder'}
        paddingRight="55px"
        inputRef={inputRef}
      />
      {!shouldHideButton && (
        <ButtonWithIcon onClick={onClick} aria-label="Search">
          <LuSearch size={24} color="white" />
        </ButtonWithIcon>
      )}
    </Flex>
  )
}
